
import { useContext, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import ClientRoutes from "./ClientRoutes";
import { AppContext } from "../../contextApi/ContextApi";
import NotFound404 from "../NotFound404";
import Loading from "../Loading";
// import { loadAllImagesData } from "../../firebase/firebase_functions"; => for future use

export default function ClientDomainRouter() {
    const { currentWebsite, isSearchingWebsite, notFound, getWebsiteByURL } = useContext(AppContext);
    const location = useLocation();
    // At any location change on url => fetch website from firestore if exists
    useLayoutEffect(()=>{
        getWebsiteByURL(location);
    },[location.pathname])
    
    // handle loading and not found cases
    if(isSearchingWebsite) return <Loading text={"אנא המתן, האתר בטעינה..."}/>
    if(notFound) return <NotFound404/>
    
    // if found and ended loading - get the client routes
    return (
        <ClientRoutes website={currentWebsite}/>
    )
}
